var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 241.1 164",
    style: {
      enableBackground: "new 0 0 241.1 164"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#fff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.6,31.9l-78.1,68.8L42.5,31.9c-3.1-2.7-7.8-2.4-10.6,0.7c-2.7,3.1-2.4,7.8,0.7,10.6l83,73.2 c1.4,1.2,3.2,1.9,5,1.9s3.5-0.6,5-1.9l83-73.2c3.1-2.7,3.4-7.5,0.7-10.6C206.4,29.4,201.7,29.1,198.6,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.6,0H22.5C10.1,0,0,10.1,0,22.5v119C0,153.9,10.1,164,22.5,164h196.1c12.4,0,22.5-10.1,22.5-22.5v-119 C241.1,10.1,231,0,218.6,0z M226.1,141.5c0,4.1-3.4,7.5-7.5,7.5H22.5c-4.1,0-7.5-3.4-7.5-7.5v-119c0-4.1,3.4-7.5,7.5-7.5h196.1 c4.1,0,7.5,3.4,7.5,7.5V141.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.6175e40fdb45a57c66c3f87bd331ff76.svg";
export { ForwardRef as ReactComponent };